import type { TableTrapGroup } from '@features/regional-overview/digital-traps/domain';
import { GroupCollapse, type GroupCollapseItem } from '@protector/components';
import {
  DAILY_COUNTS_NETWORK_GROUP_CARD,
  DAILY_COUNTS_OBSERVED_CARD_LIST
} from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import classNames from 'classnames';
import type { Dayjs } from 'dayjs';
import { DailyCountsTrapCard } from '../daily-counts-trap-card';
import styles from './daily-counts-observed-card-list.module.css';

interface DailyCountsObservedCardListProps {
  groups: TableTrapGroup[];
  anchorDate: Dayjs;
  dataTestId?: string;
}

export const DailyCountsObservedCardList = ({ groups, anchorDate, dataTestId }: DailyCountsObservedCardListProps) => {
  const collapseItems: GroupCollapseItem[] = groups.map(group => ({
    key: group.key,
    title: group.title,
    headerTestId: DAILY_COUNTS_NETWORK_GROUP_CARD,
    children: (
      <ul className={styles.cardList}>
        {group.tableDataSource.map((record, index) => (
          <li className={classNames(styles.cardListItem, { [styles.alternateRow]: index % 2 === 1 })} key={record.id}>
            <DailyCountsTrapCard record={record} anchorDate={anchorDate} isFirstInGroup={index === 0} />
          </li>
        ))}
      </ul>
    )
  }));

  return (
    <section className={styles.cardListSection} data-testid={dataTestId ?? DAILY_COUNTS_OBSERVED_CARD_LIST}>
      <GroupCollapse items={collapseItems} />
    </section>
  );
};
